import maifudLogo from "@/assets/maifud_logo.svg";
import { Footer } from "@/components";
import { BottomNav } from "@/components/Nav/BottomNav";
import { MobileNav } from "@/components/Nav/MobilNav";
import { CartProvider } from "@/services/context/CartStateContext";
import { Link } from "@tanstack/react-router";

type LayoutUserProps = {
    children: React.ReactNode;
};

export const LayoutUser = ({ children }: LayoutUserProps) => {
    return (
        <CartProvider>
            <div className="layout-background pb-24 lg:pb-0">
                <nav className="sticky top-0 z-40 flex items-center justify-between border-b bg-white/90 px-4 py-3 shadow-sm backdrop-blur lg:static lg:my-2 lg:justify-center lg:border-0 lg:bg-transparent lg:shadow-none">
                    <Link to={"/"} className="flex items-baseline">
                        <img
                            alt="Maifud Logo"
                            src={maifudLogo}
                            className="w-28 lg:w-48"
                        />
                    </Link>
                    <div className="lg:hidden">
                        <MobileNav />
                    </div>
                </nav>
                <div className="px-3 lg:mx-4 lg:px-0">{children}</div>
                <BottomNav />
            </div>
            <div className="hidden lg:block">
                <Footer />
            </div>
        </CartProvider>
    );
};
